module.exports = __webpack_public_path__ + "static/media/bethune-9.5f1bb39b.jpg";